<template>
  <BaseDialog
    v-model="showDialog"
    dialogIcon="mdi-account-circle"
    title="Profilebilde"
    subtitle="Juster profilbildet så det passer i sirkelen"
    btnActionName="Lagre"
    @action="cropImage"
  >
    <template v-slot>
      <div id="app">
        <cropper
          ref="cropper"
          class="cropper"
          :src="image.src"
          stencil-component="circle-stencil"
          :stencil-props="{
            aspectRatio: 1,
          }"
        />
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import notification from "@/helpers/notification";

export default {
  name: "App",

  props: {
    value: {
      type: Boolean,
      required: true,
    },
    image: {
      type: Object,
    },
  },
  methods: {
    cropImage() {
      const { canvas } = this.$refs.cropper.getResult();

      const form = new FormData();
      canvas.toBlob((blob) => {
        //Size to mb. Cant upload more than 4 mb
        const size = blob.size / 1048576;
        if (size < 4) {
          form.append("photo", blob);
          this.$emit("save", form);
        } else {
          notification.warn("Bildet er for stort!");
        }
      }, "image/jpeg");
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  destroyed() {
    // Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
    if (this.image.src) {
      URL.revokeObjectURL(this.image.src);
    }
  },
  components: {
    Cropper,
    BaseDialog,
  },
};
</script>

<style lang="scss" scope>
.cropper {
  // min-height: 300px;
  max-height: 400px;
  width: 100%;
}
</style>
